import React from 'react'
import Loader from 'react-loader-spinner'
import {Media, Row} from 'reactstrap'
import {ControlPanelItem} from '../../ui'
import TeamIcon from 'react-icons/lib/fa/group'
import UserIcon from 'react-icons/lib/fa/user'
import CreateTeamIcon from 'react-icons/lib/fa/user-plus'
import CreateDealerIcon from 'react-icons/lib/fa/building-o'
import ProvisionControllerIcon from 'react-icons/lib/fa/plus-square'
import AssignControllerIcon from 'react-icons/lib/fa/plus-square'
import SearchControllerIcon from 'react-icons/lib/fa/square'
import UnassignControllerIcon from 'react-icons/lib/fa/minus-square'
import RegisterControllerIcon from 'react-icons/lib/fa/asterisk'
import SubscriptionIcon from 'react-icons/lib/fa/bell'
import InvoiceIcon from 'react-icons/lib/fa/book'
import AssignDiscountIcon from 'react-icons/lib/fa/plus-square'
import DiscountLevelIcon from 'react-icons/lib/fa/percent'
import SettingIcon from 'react-icons/lib/fa/cog'
import HistoryIcon from 'react-icons/lib/fa/list'
import ReportIcon from 'react-icons/lib/fa/sticky-note'
import CellDecodeIcon from 'react-icons/lib/fa/asterisk'
import SFLogo from '../../../images/sf-logo-simple.png'
import '../../../stylesheets/ControlPanel.css'
import '../../../stylesheets/Utilities.css'

const supportItems = [
    {icon: <SearchControllerIcon/>, text: 'Search All Controllers', href: '/management/controllers'},
    {icon: <TeamIcon/>, text: 'Search All Teams', href: '/management/teams'},
    {icon: <UserIcon/>, text: 'Search All Users', href: '/management/users'},
    {icon: <CreateTeamIcon/>, text: 'Create New Team for Customer', href: '/management/teams/provision/customer'},
    {icon: <CreateDealerIcon/>, text: 'Create New Team for Dealer', href: '/management/teams/provision/dealer'},
    {icon: <ProvisionControllerIcon/>, text: 'Provision New Controller', href: '/management/controllers/provision'},
    {icon: <AssignControllerIcon/>, text: 'Assign Controllers to Team', smallText:'Assign Controllers', href: '/management/controllers/assign'},
    {icon: <UnassignControllerIcon/>, text: 'Unassign Controllers from Team', smallText:'Unassign Controllers', href: '/management/controllers/unassign'},
    {icon: <SubscriptionIcon/>, text: 'Subscription Settings', smallText:'Subscription Settings', href: '/management/controllers/subscriptionsetting'},
    {icon: <InvoiceIcon/>, text: 'Generate Invoices/Quote', smallText:'Generate Invoices/Quote', href: '/support/controllers/invoice'},
    {icon: <HistoryIcon/>, text: 'View Payment History', smallText:'Payment History', href: '/management/paymenthistory'},
    {icon: <DiscountLevelIcon/>, text: 'Discount Levels', smallText:'Discount Levels', href: '/management/controllers/discountlabelsetting'},
    {icon: <AssignDiscountIcon/>, text: 'Assign Discount to Dealer', smallText:'Assign Discounts', href: '/management/controllers/discountsetting'},
    {icon: <SettingIcon/>, text: 'Default Subscription', smallText:'Default Subscription', href: '/management/subsdefaultplan'},
    {icon: <ReportIcon/>, text: 'Generate Reports', smallText:'Reports', href: '/support/controllers/reports'},
    {icon: <TeamIcon/>, text: 'Transfer Data', href: '/management/transfercontrol'},
    {icon: <CellDecodeIcon/>, text: 'Cell Decoder', href: '/management/celldecoder'},
]

const dealerItems = [
    {icon: <RegisterControllerIcon/>, text: 'Register New Controller', href: '/dealer/controllers/register'},
    {icon: <AssignControllerIcon/>, text: 'Assign Controllers', href: '/controllers?tab=2'},
    {icon: <CreateTeamIcon/>, text: 'Create New Team for Customer', href: '/dealer/teams/provision'},
    {icon: <InvoiceIcon/>, text: 'Pay For Subscriptions', smallText:'Subscriptions', href: '/dealer/controllers/invoice'},
]

class ControlPanelPage extends React.Component {
    constructor(props) {
        super(props)
        const {user, history} = props
        this.history = history

        this.state = {
            user,
            viewDealerControls: false
        }
    }

    componentWillReceiveProps(nextProps) {
        const {user, history} = nextProps
        this.history = history

        this.setState({user})
    }

    render() {
        let {user, viewDealerControls} = this.state
        let items = []
        let title = ""
        let loading = false
        if (user && (viewDealerControls || (user.isDealer && !user.isSupport))) {
            items = dealerItems
            title = "Dealer"
        } else if (user && user.isSupport) {
            items = supportItems
            title = "Support"
        } else if (user && !user.isSupport && !user.isDealer) {
            this.history.push('/unauthorized')
        } else {
            loading = true
        }

        return <Row className="utility-container p-1 p-md-2 pb-4 justify-content-center justify-content-md-start">
            {loading ?
                <Loader type="TailSpin" color="orange" width={60} height={60}/> :
                <h1 className="col-12 font-weight-bold m-4 pb-4 text-center light-sf-blue">
                    <Media object src={SFLogo}
                           className="control-panel-logo-head d-block d-sm-inline mr-auto mr-sm-2 ml-auto ml-sm-0"/>
                    {title} Control Panel
                </h1>
            }
            {user && user.isSupport ?
                <Row className="col-12 justify-content-center mb-2">
                    <span className="switch">
                        <input type="checkbox" className="switch" id="switch-id" defaultValue={viewDealerControls} onChange={() => {
                            this.setState({viewDealerControls: !viewDealerControls})
                        }}/>
                        <label htmlFor="switch-id">Show Dealer View</label>
                    </span>
                </Row> :
                    null}
            {items.map((i, idx) =>
                <ControlPanelItem key={`${idx}-${i.text}`}
                                    icon={i.icon}
                                    text={i.text}
                                    smallText={i.smallText}
                                    href={i.href}/>
            )}
        </Row>
    }
}

export default ControlPanelPage



// WEBPACK FOOTER //
// ./src/components/pages/utilities/ControlPanelPage.js